import React from 'react';
import { Navbar } from 'react-bootstrap';
import { Link } from 'react-router-dom';

const TIKTOK_URL = 'https://www.tiktok.com/@naturesnefer';

const TikTokIcon = () => (
  <svg viewBox="0 0 24 24" aria-hidden="true">
    <path
      fill="currentColor"
      d="M19.59 6.69a4.83 4.83 0 0 1-3.77-4.25V2h-3.45v13.67a2.89 2.89 0 0 1-2.88 2.5 2.89 2.89 0 0 1-2.89-2.89 2.89 2.89 0 0 1 2.89-2.89c.28 0 .54.04.79.1V9.01a6.27 6.27 0 0 0-.79-.05 6.34 6.34 0 0 0-6.34 6.34 6.34 6.34 0 0 0 6.34 6.34 6.34 6.34 0 0 0 6.33-6.34V8.69a8.18 8.18 0 0 0 4.77 1.52V6.76a4.85 4.85 0 0 1-1-.07Z"
    />
  </svg>
);

function Footer() {
  const today = new Date();
  const year = today.getFullYear();
  return (
    <Navbar bg="light" variant="light" fixed="bottom" className="footer">
      <div className="footer-inner">
        <Navbar.Text>© Copyright {year} - Nature&apos;s Nefer</Navbar.Text>
        <nav className="footer-links" aria-label="Footer">
          <a
            className="footer-tiktok"
            href={TIKTOK_URL}
            target="_blank"
            rel="noopener noreferrer"
          >
            <TikTokIcon />
            TikTok
          </a>
          <Link to="/refund">Refund Policy</Link>
          <Link to="/privacy">Privacy Policy</Link>
          <Link to="/terms">Terms of Service</Link>
        </nav>
      </div>
    </Navbar>
  );
}

export default Footer;
